import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=63da25c2&"
import script from "./ClientEdit.vue?vue&type=script&lang=js&"
export * from "./ClientEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports